<template>
  <div id="app">
    <router-view @wxlogin="vxlogin" />
  </div>
</template>

<script>
import axios from 'axios';
import { dateChange } from "./assets/unit/util";
export default {
  data() {
    return {
      bjcolorr: this.$Store.state.bjcolor,
      ws: null,
      isDestroyed: false, // 页面是否销毁
      lockReconnect: false, // 是否真正建立连接
      timeout: 5000, // 3秒一次心跳
      timeoutObj: null, // 心跳心跳倒计时
      serverTimeoutObj: null, // 心跳倒计时
      timeoutnum: null, // 断开 重连倒计时
    };
  },
  created() {
    try {
      localStorage.removeItem("agtmainapi");
      localStorage.removeItem("agtkcmapi");
      // localStorage.removeItem('kcmapi');
      let prot = 9611;
      let windowport = window.location.port;
      if (windowport) {
        prot = windowport;
      }
      var curWwwPath = window.document.location.href;
      let protocol = document.location.protocol;
      var host = window.document.location.hostname;
      let localhostPath = `${protocol}//${host}:`;
      var origin = window.document.location.origin;

      //   var curWwwPath = window.document.location.href;
      //   var pathname = window.document.location.pathname;
      //   var pos = curWwwPath.indexOf(pathname);
      //   var localhostPath = curWwwPath.split(windowport)[0];
      if (
        localhostPath == "http://127.0.0.1:" ||
        localhostPath == "http://localhost:"
      ) {
        console.log('APPAPPAPP')
        // localhostPath = "http://www.ncerp.cn:";
        // windowport = 9610
        // windowport = 9615;
        // origin = "http://test.ncerp.cn";
        // origin = "http://erp16.cn"
        origin = "http://a.erp19.cn"
        // origin = "http://a.erp11.cn"
        // origin = "https://ncerp.cn";
      }
      //   let protocol = document.location.protocol;
      if (protocol == "file" || curWwwPath.substring(0, 4) == "file") {
        // localhostPath = "https://www.ncerp.cn:";
        // windowport = 9611;
        origin = "http://test.ncerp.cn";
        // origin = "https://ncerp.cn";
      }

      console.log("origin", origin)
      axios.defaults.baseURL = origin + "/erp/"
      localStorage.setItem('agtmainapi', origin + "/erp/");
      localStorage.setItem('agtkcmapi', origin + "/kcm/");
			window.addEventListener("beforeunload", (e) => this.loadfun(e));
      //   var ishttps = "https:" == protocol ? true : false;
      //   if (ishttps) {
      //     prot = 9611;
      //     if (windowport) {
      //       prot = windowport;
      //     }
      //     localStorage.setItem("agtmainapi", localhostPath + prot + "/erp/");
      //     // localStorage.setItem('kcmapi',localhostPath+prot+"/kcm/")
      //   } else {
      //     prot = 9610;
      //     if (windowport) {
      //       prot = windowport;
      //     }
      //     localStorage.setItem("agtmainapi", localhostPath + prot + "/erp/");
      //     // localStorage.setItem('kcmapi',localhostPath+prot+"/kcm/")
      //   }
      //   if (windowport == "9614" || windowport == "9615") {
      //     this.$message.success("当前请求路径为测试端口");
      //   }
    } catch (e) { }
  },
  mounted() {
    if (localStorage.getItem("agtsscolor")) {
      this.$Store.dispatch("onchangColor", localStorage.getItem("agtsscolor"));
      this.bjcolorr = localStorage.getItem("agtsscolor");
    }
			window.addEventListener("beforeunload", (e) => this.loadfun(e));
    // 禁用鼠标右键
    document.oncontextmenu = function () {
      return false;
    };
    history.go(1);
  },
  beforeDestroy() {
    this.isDestroyed = true;
    this.timeoutnum && clearTimeout(this.timeoutnum);
    this.timeoutObj && clearTimeout(this.timeoutObj);
    this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
    this.ws.close(); // 关闭ws
		window.removeEventListener("beforeunload", (e) => this.loadfun(e));
  },
  methods: {
    initWebSocket() {
      const _this = this;
      // 判断页面有没有存在websocket连接    
      if (window.WebSocket) {
        _this.ws = new WebSocket("wss://app.ncerp.cn:9611/ws/system");
        _this.ws.onopen = function (e) {
          _this.log("服务器连接成功");
          _this.start(); // 开启心跳
        };
        _this.ws.onclose = function (e) {
          _this.log("服务器连接关闭");
          _this.reconnect(); // 重连
        };
        _this.ws.onerror = function (e) {
          _this.log("服务器连接出错");
          _this.reconnect(); // 重连
        };
        _this.ws.onmessage = function (e) {
          // _this.log('onmessage',JSON.parse(e.data))
          _this.reset(); // 心跳重置
          // 接收服务器返回的数据
          let resData = JSON.parse(e.data);
          // let resData = e.data
          if (resData.cmd == "ping") {
            // 心跳消息
            _this.log("ping");
            return;
          }
          if (resData.cmd == "vxscanlogin") {
            // 心跳消息
            _this.log("vxscanlogin", resData.object);
            if (resData.object) {
              localStorage.setItem(
                "agtuserinfo",
                JSON.stringify(resData.object.data)
              );
              localStorage.setItem("agttoken", resData.object.data.ftoken);
              localStorage.setItem(
                "agtcompany",
                resData.object.data.fconfig.link.agt.linkname
              );
              localStorage.setItem(
                "agtlogintime",
                dateChange("dateTime", new Date())
              );
              _this.$router.push("/home");
            }
            return;
          }
          // 业务消息
        };
      }
    },
    // 重新连接
    reconnect() {
      var self = this;
      if (self.lockReconnect || self.isDestroyed) {
        return;
      }
      self.log("重新连接。。。");
      self.lockReconnect = true;
      // 没连接上会一直重连，设置延迟避免请求过多
      self.timeoutnum && clearTimeout(self.timeoutnum);
      self.timeoutnum = setTimeout(function () {
        // 新连接
        self.initWebSocket();
        self.lockReconnect = false;
      }, 4000);
    },
    // 重置心跳
    reset() {
      var self = this;
      // 清除时间
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      // 重启心
      self.start();
    },
    start() {
      let self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        // self.log(self.ws.readyState)
        // 这里发送一个心跳，后端收到后，返回一个心跳消息
        if (self.ws.readyState === 1) {
          // 判断连接是否正常
          let ojb_params = {
            cmd: "ping",
            sub: "",
            token: self.scokettoken,
            id: self.scoketid,
            owner: {
              userid: -1,
              linkid: -1,
              teamid: -1,
              system: "erp",
              visit: "web",
              naviid: -1,
              pageid: -1,
              dataid: -1,
              bodyid: -1,
            },
            data: "",
            sendto: null,
            object: null,
            array: null,
          };

          self.ws.send(JSON.stringify(ojb_params));
        } else {
          // 否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function () {
          self.log("1111111", 430);
          self.ws.close(); // 超过3秒没收到心跳消息关闭重连
        }, self.timeout);
      }, self.timeout);
    },
    vxlogin(e) {
      this.log(e);
      let ojb_params = {
        cmd: "vxscanlogin",
        sub: "connect",
        token: e.scokettoken,
        id: e.scoketid,
        owner: {
          userid: -1,
          linkid: -1,
          teamid: -1,
          system: "erp",
          visit: "web",
          naviid: -1,
          pageid: -1,
          dataid: -1,
          bodyid: -1,
        },
        data: "",
        sendto: null,
        object: null,
        array: null,
      };

      this.ws.send(JSON.stringify(ojb_params));
    },
    loadfun(e) {
				e = e || window.event;
				if (e) {
					e.returnValue = "您是否确认离开此页面-您输入的数据可能不会被保存";
				}
				return "您是否确认离开此页面-您输入的数据可能不会被保存";
				document.body.setAttribute("id", "appLoading");
			},
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
  margin: 0;
}

.el-autocomplete-suggestion li {
  font-size: 12px;
  padding: 0 10px;
}

.el-cascader-panel .el-radio {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
  top: 10px;
  right: 10px;
}

.el-cascader-panel .el-radio__input {
  visibility: hidden;
}

.el-select-dropdown__item {
  z-index: 9999;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  color: #4dc2e6;
}

.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 100px !important;
}

.el-submenu .el-menu-item {
  min-width: 100px !important;
}

.el-submenu__title * {
  vertical-align: inherit;
  color: #303133;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #303133;
}

.el-submenu__title i {
  color: #303133;
}

.vxe-modal--wrapper .vxe-modal--content{
  white-space: nowrap !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue